















































































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import CadastroLayoutEmailStore from '@/components/RemuneracaoMedica/financeiro/Store/CadastroLayoutEmailStore'
import EventBus from '@/plugins/EventBus'
import { estiloInlineDirective } from '../estilosInlineCsp'

const ATRIBUTOS_LAYOUT = ['style', 'class', 'align', 'valign', 'width', 'height', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'colspan', 'rowspan']

// O layout é HTML cadastrado pelo hospital: a lista global do VueSanitize removeria tabela, imagem e span do e-mail.
const OPCOES_SANITIZE_EMAIL = {
  allowedTags: [
    'a', 'b', 'i', 'u', 'strong', 'em', 'p', 'br', 'hr', 'span', 'div', 'font', 'center', 'small', 'sup', 'sub',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'blockquote',
    'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'img',
  ],
  allowedAttributes: {
    '*': ATRIBUTOS_LAYOUT,
    a: [...ATRIBUTOS_LAYOUT, 'href', 'target', 'title'],
    img: [...ATRIBUTOS_LAYOUT, 'src', 'alt', 'title'],
    font: [...ATRIBUTOS_LAYOUT, 'color', 'face', 'size'],
  },
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesByTag: { img: ['http', 'https', 'data'] },
}

@Component({
  directives: { estiloInline: estiloInlineDirective },
})
export default class ModalNotificacaoEmailPreview extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean
  @Prop({ type: String, default: '0' }) envioEmail!: string

  @Emit('close')
  close() { }

  currentTab: string = 'tab-0'
  loadTemplate: boolean = false
  loadingConfig: boolean = false
  opcoesSanitizeEmail = OPCOES_SANITIZE_EMAIL

  get getFinanceiroStore() { return getModule(FinanceiroStore, this.$store) }
  get getStore() { return getModule(CadastroLayoutEmailStore, this.$store) }
  get templateNotificarConfig() { return this.getFinanceiroStore.templateNotificarConfig }
  get emailCorpoNotificar() { return this.getStore.emailCorpo }
  get assuntoEmail() { return this.getStore.assunto }
  get emailContato() { return this.getStore.emailContato }
  get emailRodapeNotificar() { return this.getStore.emailRodape }

  showMockData: boolean = true

  get currentDateMock() {
    const today = new Date()
    return today.toLocaleDateString('pt-BR')
  }

  get emailPrestadorText() {
    return this.showMockData ? 'contato@clinicasilva.com.br' : '{{ p.EmailPrestador }}'
  }

  get emailContatoText() {
    return this.showMockData ? (this.emailContato || 'financeiro@hospital.com.br') : '{{ p.EmailContato }}'
  }

  get formattedEmailCorpoNotificar() {
    let template = this.emailCorpoNotificar || ''
    const rodape = this.emailRodapeNotificar || ''

    if (rodape) {
      template += `<br><br>${rodape}`
    }

    if (this.showMockData) {
      const mockHtml = (val: string) => `<span style="background-color: #E3F2FD; padding: 2px 4px; border-radius: 4px; font-weight: 500; color: #1565C0;">${val}</span>`

      template = template.replace(/\{\{\s*p\.Url\s*\}\}/g, 'https://www.portalfinx.com.br/inicio')
      template = template.replace(/\{\{\s*p\.EmailContato\s*\}\}/g, 'contato@hospital.com.br')
      template = template.replace(/\{\{\s*p\.EmailPrestador\s*\}\}/g, 'joao.silva@clinica.com.br')

      template = template.replace(/\{\{\s*p\.ValorNotaFiscal\s*\}\}/g, mockHtml('5.430,00'))
      template = template.replace(/\{\{\s*p\.RazaoSocial\s*\}\}/g, mockHtml('Hospital Exemplo'))
      template = template.replace(/\{\{\s*p\.Cnpj\s*\}\}/g, mockHtml('12.345.678/0001-90'))
      template = template.replace(/\{\{\s*p\.Endereco\s*\}\}/g, mockHtml('Av. Paulista, 1000 - São Paulo, SP'))
      template = template.replace(/\{\{\s*p\.PrestadorNome\s*\}\}/g, mockHtml('Dr. João Silva'))
      template = template.replace(/\{\{\s*p\.NomeMedico\s*\}\}/g, mockHtml('João Silva'))
      template = template.replace(/\{\{\s*p\.NomeResponsavel\s*\}\}/g, mockHtml('João Silva'))
      template = template.replace(/\{\{\s*p\.NomeHospital\s*\}\}/g, mockHtml('Hospital Exemplo'))
      template = template.replace(/\{\{\s*p\.InscricaoMunicipal\s*\}\}/g, mockHtml('1234567-8'))
      template = template.replace(/\{\{\s*p\.MesAnoReference\s*\}\}/g, mockHtml('08/2026'))
      template = template.replace(/\{\{\s*p\.Competencia\s*\}\}/g, mockHtml('Agosto/2026'))
      template = template.replace(/\{\{\s*p\.NumeroRepasse\s*\}\}/g, mockHtml('102030'))
      template = template.replace(/\{\{\s*p\.Prazo\s*\}\}/g, mockHtml('15/09/2026'))
      template = template.replace(/\{\{\s*p\.PrazoHora\s*\}\}/g, mockHtml('18:00'))

      template = template.replace(/\{\{\s*([^}]+)\s*\}\}/g, '[$1 Fictício]')
    }

    return template
  }

  @Watch('visible')
  async onVisibleChanged(val: boolean) {
    if (val) {
      this.currentTab = 'tab-0'
      this.loadingConfig = true
      this.$emit('update:loading', true)

      const param = { envioEmailTipo: parseInt(this.envioEmail, 10) }
      const response = await this.getFinanceiroStore.getTemplateNotificacaoConfig(param)

      if (response.success) {
        await this.getLayoutEmailById()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema ao pré-visualizar o template.', icon: 'warning', color: '#C62828' })
        this.close()
      }
      this.loadingConfig = false
      this.$emit('update:loading', false)
    }
  }

  @Watch('currentTab')
  async onChangeCurrentTab(newVal: string, oldVal: string) {
    // Com uma carga em andamento, ela mesma busca a aba nova ao terminar (ver getLayoutEmailById).
    if (this.visible && newVal !== oldVal && newVal && !this.loadingConfig && !this.loadTemplate) {
      await this.getLayoutEmailById()
    }
  }

  // Uma carga por vez: o layout fica no store, e duas respostas fora de ordem mostrariam o template de outra aba.
  async getLayoutEmailById() {
    this.loadTemplate = true
    let abaCarregada = ''

    while (abaCarregada !== this.currentTab) {
      abaCarregada = this.currentTab
      const index = parseInt(abaCarregada.replace('tab-', ''), 10)
      const hospital = this.templateNotificarConfig && this.templateNotificarConfig[index]
      if (!hospital) break

      // eslint-disable-next-line no-await-in-loop
      const response = await this.getStore.getLayoutEmailById({ hospitalId: hospital.hospitalId, tipoNome: this.envioEmail })
      if (!response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível carregar o layout do e-mail deste hospital.', icon: 'warning', color: '#C62828' })
        break
      }
    }

    this.loadTemplate = false
  }
}
